// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"71":"497ca44e","194":"6ef00765","225":"3602d227","558":"ed9d1472","565":"5323c39e","624":"8fa29b37","721":"e3f14b76","910":"ff26aca2"}[chunkId] + ".chunk.js";
};